(function(){
  window.__piCartVer='modal-v17';
  if (window.PI_STICKY_ATC_OFF === undefined) window.PI_STICKY_ATC_OFF = true;
  if (window.PI_ROUND_BTNS === undefined) window.PI_ROUND_BTNS = true;
  var KLAVIYO_COMPANY='WXYSVP';
  if (window.PI_KLAVIYO_FORM_ID === undefined) window.PI_KLAVIYO_FORM_ID = 'TXTY9F';
  /* product handle -> restock note. Set value to '' or remove to clear once restocked. */
  if (window.PI_RESTOCK === undefined) window.PI_RESTOCK = {'buckle-bag-noir':'Restock July 10th','buckle-bag-noir-copy':'Restock July 10th'};

  function loadKlaviyo(){
    window._klOnsite = window._klOnsite || [];
    if (window.klaviyo || document.querySelector('script[src*="static.klaviyo.com"]')) return;
    var s=document.createElement('script');
    s.async=true; s.type='text/javascript';
    s.src='https://static.klaviyo.com/onsite/js/klaviyo.js?company_id='+KLAVIYO_COMPANY;
    (document.head||document.documentElement).appendChild(s);
  }
  loadKlaviyo();

  function openKlaviyo(){
    var id = window.PI_KLAVIYO_FORM_ID; if(!id) return false;
    var n=0;
    (function go(){
      if (window.klaviyo && typeof window.klaviyo.openForm==='function'){ try{ window.klaviyo.openForm(id); }catch(e){} return; }
      window._klOnsite = window._klOnsite || [];
      if (n===0) window._klOnsite.push(['openForm', id]);
      if (n++ < 30) setTimeout(go, 250);
    })();
    return true;
  }
  function installPromoRewire(){
    if (window.__piPromoKlaviyo) return;
    window.__piPromoKlaviyo = true;
    document.addEventListener('click', function(e){
      var t=e.target;
      if (!t || !t.closest) return;
      if (t.closest('.pi-promo__x')) return;
      var hit = t.closest('.pi-promo__btn, .pi-promo, .pi-subscribe-offer, #pi-subscribe-offer');
      if (!hit) return;
      if (window.PI_KLAVIYO_FORM_ID){ e.preventDefault(); e.stopImmediatePropagation(); openKlaviyo(); }
    }, true);
  }

  function installMenuFix(){
    if (window.__piMenuFix) return;
    var details = document.querySelector('header-drawer details, .menu-drawer-container details');
    if (!details) return;
    window.__piMenuFix = true;
    function upd(){
      var open = details.hasAttribute('open');
      document.querySelectorAll('#pi-hero-ov').forEach(function(h){
        h.style.setProperty('visibility', open?'hidden':'visible','important');
        h.style.setProperty('opacity', open?'0':'1','important');
      });
    }
    try{ new MutationObserver(upd).observe(details, {attributes:true, attributeFilter:['open']}); }catch(e){}
    details.addEventListener('toggle', upd);
    upd();
  }

  /* ---- Restock badge: replace SOLD OUT with a restock note on listed products (cards + PDP) ---- */
  function restockBadge(){
    var R = window.PI_RESTOCK || {};
    document.querySelectorAll('.card-wrapper, .product-card-wrapper').forEach(function(c){
      var a=c.querySelector('a[href*="/products/"]'); if(!a) return;
      var h=a.getAttribute('href').split('/products/')[1].split('?')[0].split('/')[0];
      if(!R[h]) return;
      c.querySelectorAll('.card__badge').forEach(function(b){ b.style.setProperty('display','none','important'); });
      var media=c.querySelector('.card__media')||c.querySelector('.card__inner')||c;
      if(media && !media.querySelector('.pi-restock-badge')){
        if(getComputedStyle(media).position==='static') media.style.position='relative';
        var s=document.createElement('span'); s.className='pi-restock-badge'; s.textContent=R[h]; media.appendChild(s);
      }
    });
    if(/\/products\//.test(location.pathname)){
      var ph=location.pathname.split('/products/')[1].split('?')[0].split('/')[0];
      if(R[ph]){
        var host=document.querySelector('.product__media-wrapper');
        if(host){
          host.querySelectorAll('.card__badge').forEach(function(b){ b.style.setProperty('display','none','important'); });
          if(!host.querySelector('.pi-restock-badge')){
            if(getComputedStyle(host).position==='static') host.style.position='relative';
            var s2=document.createElement('span'); s2.className='pi-restock-badge'; s2.textContent=R[ph]; host.appendChild(s2);
          }
        }
      }
    }
  }

  function piSetShipNote(){
    var note = document.querySelector('.pi-ship-note');
    if (!note) return;
    var isLeather = (window.__piShipTags||[]).indexOf('leather') > -1;
    var txt = isLeather
      ? 'Made to Order. Free Shipping Globally. Duties & Tariffs Paid For. Ships in 1–2 weeks.'
      : 'Free Shipping Globally. Duties & Tariffs Paid For.';
    if (note.textContent !== txt) note.textContent = txt;
  }
  function shipNote(){
    if (!/\/products\//.test(location.pathname)) return;
    if (!document.querySelector('.pi-ship-note')) return;
    var handle = location.pathname.split('/products/')[1].split('/')[0].split('?')[0];
    if (window.__piShipHandle !== handle){
      if (window.__piShipFetching) return;
      window.__piShipFetching = true;
      window.__piShipHandle = handle;
      window.__piShipTags = undefined;
      fetch('/products/'+handle+'.js').then(function(r){return r.json();}).then(function(p){
        window.__piShipTags = (p.tags||[]).map(function(t){return String(t).toLowerCase();});
      }).catch(function(){ window.__piShipTags=[]; }).then(function(){ window.__piShipFetching=false; piSetShipNote(); });
      return;
    }
    if (window.__piShipTags !== undefined) piSetShipNote();
  }

  if (!document.getElementById('pi-cart-style')){
    var st=document.createElement('style'); st.id='pi-cart-style';
    st.textContent =
'.pi-ship-note{-webkit-text-stroke:0.5px currentColor!important;margin:20px 0!important;}'+
      '.pi-trust{order:6;display:flex;justify-content:center;flex-wrap:wrap;gap:6px 16px;margin:12px 0 2px;font-size:11.5px;letter-spacing:.02em;color:#333;}'+
      '.pi-trust span{display:inline-flex;align-items:center;gap:5px;white-space:nowrap;}'+      '.pi-reward{padding:2px 0 0;}'+
      '.pi-reward__label{font-size:12px;letter-spacing:0.03em;color:#111;margin-bottom:9px;}'+
      '.pi-reward__label b{font-weight:600;}'+
      '.pi-reward__track{height:4px;background:#e7e3db;border-radius:999px;overflow:hidden;}'+
      '.pi-reward__fill{height:100%;background:#111;border-radius:999px;transition:width .4s ease;}'+
      /* Cart slides in from the right as a full-height panel (full screen on phones), like the Bare Knuckles reference. */
      'cart-drawer .drawer__inner{position:fixed!important;top:0!important;right:0!important;left:auto!important;bottom:0!important;width:min(100vw,460px)!important;max-width:460px!important;height:100%!important;max-height:none!important;border-radius:0!important;border:0!important;overflow:hidden!important;display:flex!important;flex-direction:column!important;transition:transform .38s cubic-bezier(.22,.8,.24,1),visibility .38s!important;box-shadow:-24px 0 60px rgba(0,0,0,.10);}'+
      '@media screen and (max-width:749px){cart-drawer .drawer__inner{width:100vw!important;max-width:100vw!important;}}'+
      'cart-drawer .drawer__overlay, cart-drawer .cart-drawer__overlay{transition:opacity .38s ease,backdrop-filter .38s ease!important;}'+
      'cart-drawer.active .drawer__overlay, cart-drawer.active .cart-drawer__overlay{background:rgba(255,255,255,.35)!important;backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);}'+
      'cart-drawer .drawer__header{order:1;flex:0 0 auto;}'+
      'cart-drawer #comp-ship-line{order:2;flex:0 0 auto;}'+
      'cart-drawer cart-drawer-items{order:3;flex:1 1 auto;overflow-y:auto;min-height:0;}'+
      'cart-drawer .drawer__footer{order:4;flex:0 0 auto;}'+
      '.header__icon--cart{color:#1a1a1a!important;opacity:1!important;visibility:visible!important;font-size:0!important;}'+
      '.header__icon--cart .pi-bag{display:block!important;stroke:#1a1a1a!important;flex:0 0 auto!important;width:20px!important;height:20px!important;min-width:20px!important;}'+
      '.header__icon--cart .cart-count-bubble{font-size:10px!important;}';
    document.head.appendChild(st);
  }

  function installCardNav(){
    if (window.__piCardNavCapture) return;
    window.__piCardNavCapture = true;
    document.addEventListener('click', function(e){
      var t = e.target;
      if (!t || !t.closest) return;
      var card = t.closest('.card-wrapper, .product-card-wrapper');
      if (!card) return;
      if (t.closest('.pi-card-bag, button, [name="add"], input, label, select, [class*="swiper-button"], [class*="pagination"], .pi-feed__add, .quick-add__submit')) return;
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = href;
    }, true);
  }

  function roundBtns(){
    if (!window.PI_ROUND_BTNS) return;
    document.querySelectorAll('.product-form__submit, .product-form__buttons button[name="add"], button.product-form__submit').forEach(function(b){
      b.style.setProperty('border-radius','999px','important');
      b.style.setProperty('overflow','hidden','important');
    });
    document.querySelectorAll('shop-pay-wallet-button, [is="shop-pay-wallet-button"]').forEach(function(b){
      b.style.setProperty('border-radius','999px','important');
      b.style.setProperty('overflow','hidden','important');
      b.style.setProperty('display','block','important');
    });
  }

  function stickyAtcToggle(){
    if (window.PI_STICKY_ATC_OFF){
      document.querySelectorAll('.pi-sticky-atc').forEach(function(b){ b.style.setProperty('display','none','important'); });
      document.body.classList.remove('pi-atc-on');
      document.body.style.setProperty('padding-bottom','0','important');
    }
  }

  function cartIcon(){
    document.querySelectorAll('.header__icon--cart').forEach(function(a){
      if (a.querySelector('svg') || a.querySelector('.pi-bag')) return;
      a.insertAdjacentHTML('afterbegin', '<svg class="pi-bag" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#1a1a1a" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 8h12l-1 12H7L6 8z"></path><path d="M9 8V6a3 3 0 0 1 6 0v2"></path></svg>');
    });
  }

  function centerDrawer(){
    document.querySelectorAll('cart-drawer').forEach(function(cd){
      var inner=cd.querySelector('.drawer__inner'); if(!inner) return;
      var active=cd.classList.contains('active');
      inner.style.setProperty('transform', active?'translateX(0)':'translateX(100%)','important');
      inner.style.setProperty('opacity', '1','important');
      inner.style.setProperty('visibility', active?'visible':'hidden','important');
      if(!cd.__piClassObs){ cd.__piClassObs=true; new MutationObserver(function(){ centerDrawer(); }).observe(cd,{attributes:true,attributeFilter:['class']}); }
    });
  }

  function money(c){ var n=c/100; return '$'+(n%1?n.toFixed(2):n.toFixed(0)); }
  function rewardBar(){
    document.querySelectorAll('#comp-ship-line').forEach(function(c){
      var threshold=parseInt(c.getAttribute('data-threshold')||'0',10);
      var total=parseInt(c.getAttribute('data-total')||'0',10);
      if(!threshold) return;
      var remaining=threshold-total;
      var pct=Math.max(4, Math.min(100, Math.round(total/threshold*100)));
      var bar=c.querySelector(':scope > .pi-reward');
      if(!bar){ bar=document.createElement('div'); bar.className='pi-reward'; bar.innerHTML='<div class="pi-reward__label"></div><div class="pi-reward__track"><div class="pi-reward__fill"></div></div>'; c.appendChild(bar); }
      /* Once free shipping is reached the section heading already says so; don't repeat it. */
      var lbl=bar.querySelector('.pi-reward__label'); lbl.innerHTML = remaining>0 ? ('<b>'+money(remaining)+'</b> away from free shipping') : ''; lbl.style.display = remaining>0 ? '' : 'none';
      bar.querySelector('.pi-reward__fill').style.width = (remaining>0?pct:100) + '%';
    });
  }

  function setBtn(b, label, primary){
    var I = function(p, v){ b.style.setProperty(p, v, 'important'); };
    I('height','56px'); I('min-height','56px'); I('max-height','56px');
    I('display','flex'); I('align-items','center'); I('justify-content','center');
    I('padding','0 18px'); I('line-height','1'); I('width','100%'); I('box-sizing','border-box');
    if (primary){ I('background','#111'); I('border','1px solid #111'); } else { I('background','#fff'); I('border','1px solid #ddd9d1'); I('box-shadow','none'); }
    var span = b.querySelector(':scope > .pi-btn-label');
    if (!span){
      Array.prototype.slice.call(b.childNodes).forEach(function(n){ if(n.nodeType===3) n.textContent=''; });
      Array.prototype.forEach.call(b.children, function(c){ c.style.setProperty('display','none','important'); });
      span = document.createElement('span'); span.className='pi-btn-label'; b.appendChild(span);
    } else { Array.prototype.forEach.call(b.children, function(c){ if(c!==span) c.style.setProperty('display','none','important'); }); }
    if (span.textContent !== label) span.textContent = label;
    span.style.cssText = 'display:inline-block;font-size:12px;letter-spacing:0.16em;text-transform:uppercase;line-height:1;color:'+(primary?'#fff':'#111')+';';
  }
  function fixButtons(){
    document.querySelectorAll('.onward-opt-out-link').forEach(function(b){ setBtn(b, 'Checkout', true); });
    document.querySelectorAll('#main-cart-footer .cart__ctas, cart-drawer .cart__ctas, .drawer__footer .cart__ctas').forEach(function(ctas){
      var done=false;
      ctas.querySelectorAll('.onward-checkout-btn').forEach(function(b){
        if (b.classList.contains('onward-opt-out-link')) return;
        if (!done){ setBtn(b, 'Checkout+', false); done=true; } else { b.style.setProperty('display','none','important'); }
      });
    });
  }

  /* Cart + cart drawer: a returns/secure-checkout row sits under the checkout buttons (the Redo toggle already sells free returns).
     Made-to-order (MTO / leather) pieces are exchange-only, so a cart holding one drops the "14-day returns" claim. */
  window.__piTagCache = window.__piTagCache || {};
  function piCartHandles(scope){
    var seen={}, out=[];
    scope.querySelectorAll('a[href*="/products/"]').forEach(function(a){
      var h=(a.getAttribute('href')||'').split('/products/')[1]; if(!h) return;
      h=h.split('?')[0].split('#')[0].split('/')[0]; if(h && !seen[h]){ seen[h]=1; out.push(h); }
    });
    return out;
  }
  function piIsMto(tags){ return tags.indexOf('mto')>-1 || tags.indexOf('leather')>-1; }
  function retCart(){
    document.querySelectorAll('#main-cart-footer .cart__ctas, cart-drawer .cart__ctas').forEach(function(ctas){
      var box = ctas.parentNode; if(!box) return;
      var trust = box.querySelector(':scope > .pi-trust');
      if(!trust){ trust=document.createElement('div'); trust.className='pi-trust'; }
      if(ctas.nextElementSibling!==trust) box.insertBefore(trust, ctas.nextSibling);
      var scope = ctas.closest('cart-drawer') || document.querySelector('cart-items') || document;
      var hs = piCartHandles(scope), pending=false, mto=false;
      hs.forEach(function(h){
        var t = window.__piTagCache[h];
        if(t===undefined){
          pending=true; window.__piTagCache[h]=null;
          fetch('/products/'+h+'.js').then(function(r){return r.json();}).then(function(p){
            window.__piTagCache[h]=(p.tags||[]).map(function(x){return String(x).toLowerCase();});
          }).catch(function(){ window.__piTagCache[h]=[]; }).then(retCart);
        } else if(t===null){ pending=true; } else if(piIsMto(t)){ mto=true; }
      });
      var key = mto ? 'mto' : 'std';
      if(trust.getAttribute('data-k')===key) return;
      if(pending && !mto && trust.getAttribute('data-k')) return;
      trust.setAttribute('data-k', key);
      var ic = {
        ret:'<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/></svg>',
        ex:'<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M7 7h13l-3-3M17 17H4l3 3"/></svg>',
        lock:'<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><rect x="5" y="11" width="14" height="9" rx="1"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>'
      };
      trust.innerHTML = (mto ? '<span>'+ic.ret+'No refunds on made-to-order</span>' : '<span>'+ic.ret+'14-day returns</span>') + '<span>'+ic.ex+'30-day exchanges</span><span>'+ic.lock+'Secure checkout</span>';
    });
  }
  function apply(){ cartIcon(); centerDrawer(); rewardBar(); fixButtons(); stickyAtcToggle(); roundBtns(); shipNote(); installMenuFix(); restockBadge(); retCart(); }
  function start(){
    installPromoRewire();
    installCardNav();
    apply();
    var scheduled=false, mo;
    function schedule(){ if(scheduled) return; scheduled=true; requestAnimationFrame(function(){ scheduled=false; mo.disconnect(); try{ apply(); } finally { mo.observe(document.body,{childList:true,subtree:true}); } }); }
    mo = new MutationObserver(schedule);
    mo.observe(document.body,{childList:true,subtree:true});
  }
  if (document.readyState !== 'loading') start(); else document.addEventListener('DOMContentLoaded', start);
})();
